import { render } from "./Dialog.vue?vue&type=template&id=2f187a09&scoped=true"
import script from "./Dialog.vue?vue&type=script&lang=js"
export * from "./Dialog.vue?vue&type=script&lang=js"

import "./Dialog.vue?vue&type=style&index=0&id=2f187a09&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/nush-bookings/nush-bookings/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f187a09"]])

export default __exports__